import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Navigation from "@/components/Navigation";
import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import ContactMePage from "@/pages/ContactMe";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPostEditor from "@/pages/AdminPostEditor";
import LoginPage from "@/pages/LoginPage";
import PostBuilder from "@/pages/PostBuilder";
import PostViewPage from "@/pages/PostViewPage";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/blog/:id" element={<PostViewPage />} />
            <Route path="/contact" element={<ContactMePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/post/new"
              element={
                <ProtectedRoute>
                  <PostBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/post/:id"
              element={
                <ProtectedRoute>
                  <PostBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/view/:id"
              element={
                <ProtectedRoute>
                  <PostViewPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
